import React from 'react';
import clsx from 'clsx';
import formatters from 'src/utils/formatters';
import { InfoWindow } from '@react-google-maps/api';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const NO_VALUE_DEFAULT = 'N/A';
const STANDARD_DATE_FORMAT = 'PPpp';

const getInfoWindowOptions = () => {
  if (!window.google?.maps) return {};
  return {
    pixelOffset: new window.google.maps.Size(-5, -30)
  };
};

const useStyles = makeStyles((theme) => ({
  boldText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  centerText: {
    textAlign: 'center'
  }
}));

function DigitalDispatchInfoWindow({
  waypointData,
  onCloseClick
}) {
  const classes = useStyles();
  if (!waypointData || !window.google?.maps) return null;
  return (
    <InfoWindow
      onCloseClick={onCloseClick}
      position={{
        lat: waypointData.assignedVehicle.geoPoint.latitude,
        lng: waypointData.assignedVehicle.geoPoint.longitude + 0.001
      }}
      options={getInfoWindowOptions()}
    >
      <div>
        <Typography variant="h4" className={clsx(classes.boldText, classes.centerText)}>
          {/* Guaranteed to be present  */}
          {waypointData.assignedVehicle.gpsLastUpdate ? formatters
            .formatISODate(
              waypointData
                .assignedVehicle.gpsLastUpdate,
              STANDARD_DATE_FORMAT
            ) : NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Vehicle Coordinates:
            {' '}
          </span>
          {`latitude: ${waypointData?.assignedVehicle?.geoPoint?.latitude}`}
          <br />
          {`longitude: ${waypointData?.assignedVehicle?.geoPoint?.longitude}`}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Internal Company ID:
            {' '}
          </span>
          {waypointData
            ?.bsCompanyId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Provider ID:
            {' '}
          </span>
          {waypointData
            ?.contractorId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            ETA:
            {' '}
          </span>
          {waypointData?.eta ? `${waypointData.eta} minutes`
            : NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Job ID:
            {' '}
          </span>
          {waypointData?.jobId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            LocationID:
            {' '}
          </span>
          {waypointData
            ?.locationId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Driver Phone:
            {' '}
          </span>
          {waypointData?.phone ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Purchase Order ID:
            {' '}
          </span>
          {waypointData
            ?.purchaseOrderId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Dispatch ID:
            {' '}
          </span>
          {waypointData
            ?.dispatchId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Response ID:
            {' '}
          </span>
          {waypointData
            ?.responseId ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Destination Zip Code/Area Code:
            {' '}
          </span>
          {waypointData?.zip ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Driver Name :
            {' '}
          </span>
          {waypointData
            ?.assignedDriver?.name ?? NO_VALUE_DEFAULT}
        </Typography>
        <Typography variant="body2">
          <span className={classes.boldText}>
            Driver ID :
            {' '}
          </span>
          {waypointData
            ?.assignedDriver?.id ?? NO_VALUE_DEFAULT}
        </Typography>
      </div>
    </InfoWindow>
  );
}

DigitalDispatchInfoWindow.propTypes = {
  waypointData: PropTypes.shape({
    id: PropTypes.number,
    bsCompanyId: PropTypes.number,
    contractorId: PropTypes.string,
    eta: PropTypes.string,
    jobId: PropTypes.string,
    locationId: PropTypes.string,
    motorClubKey: PropTypes.string,
    phone: PropTypes.string,
    purchaseOrderId: PropTypes.string,
    dispatchId: PropTypes.string,
    responseId: PropTypes.string,
    zip: PropTypes.string,
    dateCreated: PropTypes.string,
    dateModified: PropTypes.string,
    sourceType: PropTypes.string,
    assignedVehicle: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      geoPoint: PropTypes.shape({
        latitude: PropTypes.number,
        longitude: PropTypes.number
      }),
      gpsLastUpdate: PropTypes.string,
      direction: PropTypes.number
    }),
    assignedDriver: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string
    })
  }),
  onCloseClick: PropTypes.func
};

export default DigitalDispatchInfoWindow;
